module.exports = __webpack_public_path__ + "7b27468902ba520db2e27431e247547c.svg";